/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Translations,
  checkJson,
  getNumberLengthFromString,
  isEmptyObject,
  loadIfStateAvailableInSessionStorage,
  removeEmptyObjectFromPayload,
  savePageStateInSessionStorage
} from '../../../../utils';

//action Creator
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
import {
  resetCorporateCardActiveTabIndex,
  resetcurrentProductCorporateCard,
  setAddresses,
  setCaptureProductCorporateCard,
  setCorporateCardActiveTabIndex,
  setPersons
} from '../../actions/actionCreator';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';

import CaseDetailAccordion, { NavListAccordionWrapper } from '../../../common/CorporateCardAccordion/corporateCardAccordion';

import { accordionFieldsMap, dropDownDataSourceMap, getCountryAccordions } from './mappingFile';


//styles
import './styles.css';

class CaptureProductCorporateCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applicableAccordions: [],
      formData: {
        specificDetails: {
          currencyType: [],
          cardType: [],
          supplierNameLst: [],
          b2bSolution: false,
          specificDetailsMandatoryCheck: false,
        },
        customerLimitList: [],
        statementFrequencyList: [],
        preferredDayList: [],
        cardtaxanomy: [],
        currency: [],
        availableAddresses: [],
        availableContacts: [],
        cardAddresses: [],
        pinAddresses: [],
        addressContactReset: false,
        addressAndContacts: {
          addressAndContactMandatoryCheck: false
        },
        statementList: []
      },
      disabledOptions: { availableAddresses: [], availableContacts: [], cardAddresses: [], pinAddresses: [] },
    }
    this.deleteKeysFromStateArr = [];
    this.dropDownDataSourceMap = dropDownDataSourceMap;
  }

  loadPageState = () => {
    var { productId, caseId } = this.props.match.params;
    eapiClient("/product/corporate-card/" + productId)
      .then(({ data }) => {
        this.updateFormData(data, null);

        return eapiClient("/persons/case/" + caseId)
      }).then(({ data }) => {
        this.setState({
          formData: {
            ...this.state.formData,
            availableContacts: data.responseData
          }
        });
        this.props.setPersons(data.responseData);

        return aemHostClient("/aemData/formData/json_corporate-card-all-closed")
      }).then(({ data }) => {
        this.setState({ pageJson: data }, () => {
          let formDataObject = {};
          for (let [accordionKey, accordionContent] of Object.entries(this.state.pageJson.par)) {
            if (accordionKey.startsWith('aemform_')) {
              formDataObject[accordionContent.name] = {}
            }
          }
          let { caseId } = this.props.match.params;
          eapiClient("/addresses/case/" + caseId)
            .then(({ data }) => {
              this.setState({
                formData: {
                  ...this.state.formData,
                  availableAddresses: data.responseData,
                  cardAddresses: data.responseData,
                  pinAddresses: data.responseData,
                }
              });
              this.props.setAddresses(data.responseData);
              this.getTaxanomyAddress();
            });
          this.getCountryTaxanomy();
          if (this.props.lang.currentLang.lang === 'Spanish') {
            this.getCorporateCardTaxanomy('ES');
          } else if (this.props.lang.currentLang.lang === 'Bahasa') {
            this.getCorporateCardTaxanomy('BA');
          } else {
            this.getCorporateCardTaxanomy('EN');
          }

        })
      });
  }

  setDropDownDataFromTaxonomy = (actionTypes = [], parm) => {
    let taxonomyData = this.state.cardtaxanomy;
    let setDataObj = {
      customerLimitList: [],
      preferredDateArray: [],
      statementFrequencyList: [],
      preferredDayList: []
    };
    if (this.state.country !== undefined && taxonomyData !== undefined) {
      for (let acType = 0; acType < actionTypes.length; acType++) {
        let Id = this.state.country.value;
        let country = taxonomyData.find(item => item.id === Id);
        if (country !== undefined) {
          for (let nodeData of country.externalIdentifiers) {
            let splitNode = nodeData.id.split(':');
            var statementFrequencyList = []
            if (splitNode[splitNode.length - 1] === actionTypes[acType]) {
              if (actionTypes[acType] === 'statementFrequency') {
                setDataObj.statementList = nodeData.classifications;
                if (this.state.formData.specificDetails.statementFrequency !== undefined && this.state.formData.specificDetails.statementFrequency.value !== undefined) {
                  let list = nodeData.classifications;
                  let day = list.find(x => x.id === this.state.formData.specificDetails.statementFrequency.value);
                  if (day !== undefined && nodeData !== undefined) {
                    nodeData.classifications.map((data) => {
                      if (typeof data.associations !== 'undefined' && data.id === this.state.formData.specificDetails.statementFrequency.value) {
                        setDataObj.preferredDayList = data.associations.map(method => { return { id: method.id, name: method.name } })
                      }
                      statementFrequencyList.push({ id: data.id, name: data.name })
                    })
                  }
                } else {
                  nodeData.classifications.map((data) => {
                    if (typeof data.associations !== 'undefined') {
                      setDataObj.preferredDayList = data.associations.map(method => { return { id: method.id, name: method.name } })
                    }
                    statementFrequencyList.push({ id: data.id, name: data.name })
                  })
                }
              }
              if (actionTypes[acType] === 'preferredDay') {
                nodeData.classifications.map((data) => {
                  if (typeof data.associations !== 'undefined') {
                    setDataObj.preferredDayList = data.associations.map(method => { return { id: method.id, name: method.name } })
                  }
                })
              }
              switch (actionTypes[acType]) {
                case 'statementFrequency':
                  setDataObj.statementFrequencyList = nodeData ? statementFrequencyList : [];
                  break;
                case 'customerLimit':
                  setDataObj.customerLimitList = nodeData ? nodeData.associations.map(method => { return { id: method.id, name: method.name } }) : [];
                  break;
                default:
                  console.log('');
              }
              if (Array.isArray(setDataObj.statementFrequencyList) && setDataObj.statementFrequencyList.length === 1 &&
                (typeof setDataObj.statementFrequencyList[0].name === "string" && setDataObj.statementFrequencyList[0].name.toLocaleLowerCase() === "monthly")
              ) {
                const formData = { ...this.state.formData }
                formData.specificDetails = { ...formData.specificDetails, statementFrequency: { ...setDataObj.statementFrequencyList[0], value: setDataObj.statementFrequencyList[0].id } }
                const data = {
                  ...formData,
                  ...setDataObj
                }
                this.setState({
                  formData: data
                })
              }
              else {
                this.setState({
                  formData: {
                    ...this.state.formData,
                    ...setDataObj,
                  }
                });
              }
            }
          }
        }
      }
    }

  }

  componentWillMount() {
    this.props.blockUi();
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });
  }

  componentDidMount() {
    let { productId, caseId } = this.props.match.params;
    eapiClient("/product/corporate-card/" + productId + "/status")
      .then(({ data }) => {
        this.setState({ status: data.responseData });
      });
    this.loadPageState();
    this.updateDropdown();
    this.props.unBlockUi();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      if (nextProps.lang.currentLang.lang === 'Spanish') {
        this.getCorporateCardTaxanomy('ES');
      } else if (nextProps.lang.currentLang.lang === 'Bahasa') {
        this.getCorporateCardTaxanomy('BA');
      } else {
        this.getCorporateCardTaxanomy('EN');
      }
      this.getTaxanomyAddress();
      this.getCountryTaxanomy();
    }

  }

  getTaxanomyAddress = () => {
    let availableAddresses = this.state.formData.availableAddresses;
    taxonomyHostClient(this.getTranslatedValue(this.state.pageJson.par.aemform_addressAndContacts.countryTaxonomy))
      .then(({ data }) => {
        let currentListCountries = data.responseData.classificationNodes;
        if (availableAddresses !== undefined) {
          availableAddresses = availableAddresses.map(item => {
            currentListCountries.filter(countItem => {
              if ('country' in item) {
                if (countItem.id === item.country.value) {
                  item.country.name = countItem.name
                }
              }
              return countItem;
            });
            this.setState({
              formData: {
                ...this.state.formData,
                availableAddresses: availableAddresses
              }
            })
            this.props.setAddresses(availableAddresses);
          });
        }
      });
  }

  getCorporateCardTaxanomy = (parm) => {
    eapiClient(this.getTranslatedValue(this.state.pageJson.par.aemform_specificDetails.ccTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          this.setState({
            formData: {
              ...this.state.formData,
            },
            cardtaxanomy: data.responseData.classificationNodes
          }, () => {
            let countryId = this.state.country ? this.state.country.value : '';
            // let splitItem = countryId.split(':');
            // let str = splitItem.slice(0, -1);;
            // str.push(parm)
            // let Id = str.join(':');
            if (this.state.cardtaxanomy !== undefined && this.state.cardtaxanomy.length > 0) {
              let currency = this.state.cardtaxanomy.find(item => item.id === countryId);
              this.setState({ currency })
            }
            this.setDropDownDataFromTaxonomy([
              'customerLimit', 'statementFrequency', 'preferredDay'
            ], parm)
          })
        }
      });
  }

  getCountryTaxanomy = () => {
    taxonomyHostClient(this.getTranslatedValue(this.state.pageJson.par.aemform_addressAndContacts.countryTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          let val = this.state.country ? this.state.country.value : '';
          if (val !== undefined && currentListCountries !== undefined) {
            let countryItem = currentListCountries.find(x => x.id === val);
            if (countryItem !== undefined) {
              let countryName = countryItem.name;
              this.setState({ countryName });
            }
          }
        }
      });
  }

  updateDropdown = () => {
    let getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    let getCurrentDropDownName, getCurrentDropDownIndex, _currentValue, _dataSourceKey, _disbaledOptionKey, _currentParent, _subMethNum, _subAccounts, _orderChain, _isAdressChecked, contactIdList;
    let getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    let _getCurrentDropDown = checkJson(getCurrentDropDown) || null;

    if (getCurrentDropDown !== null && _getCurrentDropDown) {
      if (isNaN(parseInt(_getCurrentDropDown.dropDownName.substring(_getCurrentDropDown.dropDownName.length - 1)))) {
        getCurrentDropDownName = _getCurrentDropDown.dropDownName;
      } else {
        //The function getNumberLengthFromString gets length of number appended at last with the given string, e.g achAccountsId11 -> returns 2
        let _indexLength = getNumberLengthFromString(_getCurrentDropDown.dropDownName);
        getCurrentDropDownName = _getCurrentDropDown.dropDownName.substring(0, _getCurrentDropDown.dropDownName.length - _indexLength);
        getCurrentDropDownIndex = _getCurrentDropDown.dropDownName.substring(_getCurrentDropDown.dropDownName.length - _indexLength);
      }
      _dataSourceKey = _getCurrentDropDown.dataSourceKey;
      _disbaledOptionKey = _getCurrentDropDown.disbaledOptionKey;
      _currentParent = _getCurrentDropDown.accordionName
      _orderChain = _getCurrentDropDown.orderChain
      contactIdList = this.state.formData[_getCurrentDropDown.accordionName] && this.state.formData[_getCurrentDropDown.accordionName].contactId ? [...this.state.formData[_getCurrentDropDown.accordionName].contactId] : []
    }
    if (_currentParent === 'addressAndContacts') {

      switch (getCurrentDropDownName) {
        case 'addressId':
          _currentValue = this.state.formData[_currentParent].addressId
          break;
        case 'contactId':
          _currentValue = this.state.formData[_currentParent] && this.state.formData[_currentParent].contactId && this.state.formData[_currentParent].contactId[getCurrentDropDownIndex] && this.state.formData[_currentParent].contactId[getCurrentDropDownIndex] ? this.state.formData[_currentParent].contactId[getCurrentDropDownIndex][getCurrentDropDownName] : ""
          if (Array.isArray(contactIdList)) {
            if (contactIdList[getCurrentDropDownIndex]) {
              contactIdList[getCurrentDropDownIndex][getCurrentDropDownName] = getCurrentDropDownValue
            } else if (getCurrentDropDownValue) {
              contactIdList = [...contactIdList, {
                [getCurrentDropDownName]: getCurrentDropDownValue
              }]
            }
          }
          break;
        case 'cardDeliveryAddressId':
          _currentValue = this.state.formData[_currentParent].cardDeliveryAddressId;
          _isAdressChecked = 'isDiffCardDeliveryAdd'
          break;
        case 'pinDeliveryAddressId':
          _currentValue = this.state.formData[_currentParent].pinDeliveryAddressId
          _isAdressChecked = 'isDiffPINDeliveryAdd';
          break;
      }
      this.setState({
        formData: {
          ...this.state.formData,
          [_currentParent]: {
            ...this.state.formData[_currentParent],
            [getCurrentDropDownName]: getCurrentDropDownName === "contactId" && Array.isArray(contactIdList) ? contactIdList : (getCurrentDropDownValue || this.state.formData.addressAndContacts[getCurrentDropDownName]),
            [_isAdressChecked]: true
          }
        }
      });
    }

    let updatedDisableObj = {
      currentValue: _currentValue,
      updateValue: getCurrentDropDownValue,
      dataSourceKey: _dataSourceKey,
      disbaledOptionKey: _disbaledOptionKey
    };
    this.updateDisabledArray(updatedDisableObj);

    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  handleChange = (accordionKey) => e => {

    let changedAccordionData = { ...e };
    if (e !== undefined && typeof e.statementFrequency !== 'undefined') {
      let date = this.state.formData.statementList.find(x => x.id === e.statementFrequency.value);
      this.state.formData.preferredDayList = date.associations;
    }
    if (changedAccordionData.isDiffCardDeliveryAdd !== undefined && changedAccordionData.isDiffCardDeliveryAdd === false) {
      delete changedAccordionData.cardDeliveryAddressId;
      delete this.state.disabledOptions.cardDeliveryAddressIdcardAddresses;
      delete changedAccordionData.forTheAttentionOfCard;
      delete this.state.disabledOptions.forTheAttentionOfCard;
    }
    if (changedAccordionData.isDiffPINDeliveryAdd !== undefined && changedAccordionData.isDiffPINDeliveryAdd === false) {
      delete changedAccordionData.pinDeliveryAddressId;
      delete this.state.disabledOptions.pinDeliveryAddressIdpinAddresses;
      delete changedAccordionData.forTheAttentionOfPIN;
      delete this.state.disabledOptions.forTheAttentionOfPIN;
    }
    let country = this.state.country.value.split(':')
    if (changedAccordionData.currencyType !== undefined && changedAccordionData.currencyType.length >= 0) {
      if (country !== undefined && country[country.length - 2] === 'Singapore') {
        let isVirtualCurr = changedAccordionData.currencyType.find(x => x.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Singapore:cardType:VCCentralPay:SGD");
        if (changedAccordionData.currencyType.length === 1 && isVirtualCurr !== undefined && document.querySelector('[id^="companyNameOnCard"]').classList !== null) {
          document.querySelector('[id^="companyNameOnCard"]').classList.add('noDisplay');
          delete changedAccordionData.companyNameOnCard;
        } else {
          document.querySelector('[id^="companyNameOnCard"]').classList ? document.querySelector('[id^="companyNameOnCard"]').classList.remove('noDisplay') : '';
        }
      }
    }
    if (changedAccordionData.cardType !== undefined && changedAccordionData.cardType.length !== 0 && country[country.length - 2] === 'UnitedStatesofAmerica') {
      let isCentralPay = changedAccordionData.cardType !== undefined && changedAccordionData.cardType.length !== 0 ? changedAccordionData.cardType.find(x => x.name === "Central Pay") : '';
      if (isCentralPay === undefined) {
        delete this.state.formData.addressAndContacts.isDiffCardDeliveryAdd;
        delete this.state.formData.addressAndContacts.isDiffPINDeliveryAdd;
        delete this.state.formData.addressAndContacts.forTheAttentionOfCard;
        delete this.state.formData.addressAndContacts.forTheAttentionOfPIN;
        delete this.state.formData.addressAndContacts.cardDeliveryAddressId;
        delete this.state.formData.addressAndContacts.pinDeliveryAddressId;
        delete changedAccordionData.cardDeliveryAddressId;
        delete this.state.disabledOptions.cardDeliveryAddressId;
        delete changedAccordionData.forTheAttentionOfCard;
        delete this.state.disabledOptions.forTheAttentionOfCard;
        delete changedAccordionData.pinDeliveryAddressId;
        delete this.state.disabledOptions.pinDeliveryAddressId;
        delete changedAccordionData.forTheAttentionOfPIN;
        delete this.state.disabledOptions.forTheAttentionOfPIN;
        this.setState({
          addressContactReset: true
        })
      }
      if (document.querySelector('[id^="static_text_CardsAndPINs"]') !== null && document.querySelector('[id^="isDiffCardDeliveryAdd"]') !== null && document.querySelector('[id^="isDiffPINDeliveryAdd"]') !== null) {
        if (isCentralPay !== undefined) {
          document.querySelector('[id^="static_text_CardsAndPINs"]').classList.remove('noDisplay');
          document.querySelector('[id^="isDiffCardDeliveryAdd"]').classList.remove('noDisplay');
          document.querySelector('[id^="isDiffPINDeliveryAdd"]').classList.remove('noDisplay');
        }
        else {
          document.querySelector('[id^="static_text_CardsAndPINs"]').classList.add('noDisplay');
          document.querySelector('[id^="isDiffCardDeliveryAdd"]').classList.add('noDisplay');
          document.querySelector('[id^="isDiffPINDeliveryAdd"]').classList.add('noDisplay');
        }
      }
    }
    if (changedAccordionData.cardType !== undefined && changedAccordionData.cardType.length === 0 && country[country.length - 2] === 'UnitedStatesofAmerica') {
      delete this.state.formData.addressAndContacts.isDiffCardDeliveryAdd;
      delete this.state.formData.addressAndContacts.isDiffPINDeliveryAdd;
      delete this.state.formData.addressAndContacts.forTheAttentionOfCard;
      delete this.state.formData.addressAndContacts.forTheAttentionOfPIN;
      delete this.state.formData.addressAndContacts.cardDeliveryAddressId;
      delete this.state.formData.addressAndContacts.pinDeliveryAddressId;
      delete changedAccordionData.cardDeliveryAddressId;
      delete this.state.disabledOptions.cardDeliveryAddressId;
      delete changedAccordionData.forTheAttentionOfCard;
      delete this.state.disabledOptions.forTheAttentionOfCard;
      delete changedAccordionData.pinDeliveryAddressId;
      delete this.state.disabledOptions.pinDeliveryAddressId;
      delete changedAccordionData.forTheAttentionOfPIN;
      delete this.state.disabledOptions.forTheAttentionOfPIN;
    }
    let newFormData = { ...this.state.formData, [accordionKey]: changedAccordionData };
    this.setState({
      formData: newFormData
    }, () => {
      if (this.state.formData.specificDetails.b2bSolution !== undefined) {
        let _propsGroupPosition = 9;
        let currType = this.state.formData.specificDetails.currencyType;
        let currName = [];
        for (let i = 0; i < currType.length; i++) {
          let item = currType[i].value.split(':');
          currName.push(item[_propsGroupPosition]);
        }
        let isB2BCheck = currName.find(x => x === 'CCCentralPay' || x === 'CCIndividualPay');
        if (isB2BCheck === undefined) {
          let b2bSolution = false;
          let supplierNameLst1 = null, supplierNameLst2 = null, supplierNameLst3 = null, supplierNameLst4 = null, supplierNameLst5 = null;
          this.setState({
            formData: {
              ...this.state.formData,
              specificDetails: {
                ...this.state.formData.specificDetails,
                b2bSolution,
                supplierNameLst1,
                supplierNameLst2,
                supplierNameLst3,
                supplierNameLst4,
                supplierNameLst5
              },
            }
          });
        }
      }
      this.showHideFields();
    });
  }

  // save and refresh
  submitTabdata = (data) => {
    this.props.blockUi();
    let { productId } = this.props.match.params;
    let payload = {
      productType: "corporate-card",
      id: this.props.match.params.productId,
      specificDetails: data.specificDetails,
    }
    let isSpecificDetails = data.specificDetails !== undefined ? true : false;
    let country = this.state.country.value.split(':')
    if (data.specificDetails !== undefined && country[country.length - 2] !== "UnitedStatesofAmerica") {
      delete data.specificDetails.cardAndCurrencies;
      let currency = this.state.currency;
      let card = data.specificDetails.currencyType;
      let cardArr = [];
      let cardType = [];
      if (card.length > 0) {
        for (let item of card) {
          let cc = item.value.slice(0, item.value.lastIndexOf(":"));
          let filterData = currency.associations.filter(x => x.id === cc);
          cardArr.push(filterData[0]);
        }
      }
      cardArr.map(x => cardType.filter(a => a.id == x.id).length > 0 ? null : cardType.push(x));
      if (this.state.selectedCountry === "newzealand") {
        data.specificDetails.cardType = cardType.filter(el => !!el);
      } else {
        data.specificDetails.cardType = cardType;
      }
      payload.specificDetails = data.specificDetails
      if (payload.specificDetails.supplierNameLst !== undefined) {
        let supplierArr = [];
        if (this.state.formData.specificDetails.supplierNameLst1 !== undefined) {
          supplierArr.push(payload.specificDetails.supplierNameLst1)
        } if (this.state.formData.specificDetails.supplierNameLst2 !== undefined) {
          supplierArr.push(payload.specificDetails.supplierNameLst2)
        } if (this.state.formData.specificDetails.supplierNameLst3 !== undefined) {
          supplierArr.push(payload.specificDetails.supplierNameLst3)
        } if (this.state.formData.specificDetails.supplierNameLst4 !== undefined) {
          supplierArr.push(payload.specificDetails.supplierNameLst4)
        } if (this.state.formData.specificDetails.supplierNameLst5 !== undefined) {
          supplierArr.push(payload.specificDetails.supplierNameLst5)
        }
        payload.specificDetails.supplierNameLst = supplierArr.filter(function (e) { return e });
      }
    }
    else if (data.specificDetails !== undefined && country[country.length - 2] === "UnitedStatesofAmerica") {
      delete data.specificDetails.cardAndCurrencies;
      let currency = this.state.currency;
      let card = data.specificDetails.cardType;
      let cardArr = [];
      let cardType = [];
      if (card.length > 0) {
        for (let item of card) {
          let assoc = currency.associations;
          for (let index = 0; index < assoc.length; index++) {
            let filterData = assoc[index].associations.find(x => x.id === item.value);
            cardArr.push(filterData);
          }
        }
      }
      let newArr = cardArr.filter(x => x !== undefined);
      newArr.map(x => cardType.filter(a => a.id === x.id).length > 0 ? null : cardType.push(x));
      data.specificDetails.cardType = cardType;
      payload.specificDetails = {
        ...data.specificDetails,
        addressContactReset: this.state.addressContactReset
      }
    }
    if (data.addressAndContacts !== undefined) {
      payload.addressAndContacts = data.addressAndContacts
      if (payload.addressAndContacts.addressAndContactMandatoryCheck !== undefined && payload.addressAndContacts.addressAndContactMandatoryCheck === false) {
        delete payload.addressAndContacts.addressAndContactMandatoryCheck;
      }
      if (Array.isArray(payload.addressAndContacts.contactId) && payload.addressAndContacts.contactId.length) {
        removeEmptyObjectFromPayload(payload.addressAndContacts)
      }
    }
    if (payload.specificDetails !== undefined && payload.specificDetails.specificDetailsMandatoryCheck !== undefined && payload.specificDetails.specificDetailsMandatoryCheck === false) {
      delete payload.specificDetails.specificDetailsMandatoryCheck;
    }

    let finalPayload = { product: payload }
    eapiClient("/product/corporate-card/" + productId, {
      method: 'PUT',
      data: JSON.stringify(finalPayload)
    })
      .then(({ data }) => {
        let isItem = window.sessionStorage.getItem("isItem");
        if (isItem !== null) {
          window.sessionStorage.removeItem("isItem");
        }
        this.setState({
          addressContactReset: false
        })
        this.updateFormData(data, isSpecificDetails);
        eapiClient("/product/corporate-card/" + productId + "/status")
          .then(({ data }) => {
            this.setState({ status: data.responseData }, () => { console.log(">>>", this.state.status) });
            this.props.unBlockUi();
          });
      })
  }

  //save and Return payLoad
  submitFormData = () => {
    this.props.blockUi();
    let Payload = new SaveAndReturnPayload();
    Payload.setPayLoad(this.state.formData);
    let { productId } = this.props.match.params;
    let finalPayload = {};
    let country = this.state.country.value.split(':')
    if (Payload.data.specificDetails !== undefined && country[country.length - 2] !== "UnitedStatesofAmerica") {
      delete Payload.data.specificDetails.cardAndCurrencies;
      let currency = this.state.currency;
      let card = Payload.data.specificDetails.currencyType;
      let cardArr = [];
      let cardType = [];
      if (card.length > 0) {
        for (let item of card) {
          let cc = item.value.slice(0, item.value.lastIndexOf(":"));
          let filterData = currency.associations.filter(x => x.id === cc);
          cardArr.push(filterData[0]);
        }
      }
      cardArr.map(x => cardType.filter(a => a.id == x.id).length > 0 ? null : cardType.push(x));
      if (this.state.selectedCountry === "newzealand") {
        Payload.data.specificDetails.cardType = cardType.filter(el => !!el);
      } else {
        Payload.data.specificDetails.cardType = cardType;
      }
      if (Payload.data.specificDetails.supplierNameLst !== undefined) {
        let supplierArr = [];
        if (this.state.formData.specificDetails.supplierNameLst1 !== undefined) {
          supplierArr.push(Payload.data.specificDetails.supplierNameLst1)
        } if (this.state.formData.specificDetails.supplierNameLst2 !== undefined) {
          supplierArr.push(Payload.data.specificDetails.supplierNameLst2)
        } if (this.state.formData.specificDetails.supplierNameLst3 !== undefined) {
          supplierArr.push(Payload.data.specificDetails.supplierNameLst3)
        } if (this.state.formData.specificDetails.supplierNameLst4 !== undefined) {
          supplierArr.push(Payload.data.specificDetails.supplierNameLst4)
        } if (this.state.formData.specificDetails.supplierNameLst5 !== undefined) {
          supplierArr.push(Payload.data.specificDetails.supplierNameLst5)
        }
        Payload.data.specificDetails.supplierNameLst = supplierArr.filter(function (e) { return e });
      }
    }
    else if (Payload.data.specificDetails !== undefined && country[country.length - 2] === "UnitedStatesofAmerica") {
      delete Payload.data.specificDetails.cardAndCurrencies;
      let currency = this.state.currency;
      let card = Payload.data.specificDetails.cardType;
      let cardArr = [];
      let cardType = [];
      if (card.length > 0) {
        for (let item of card) {
          let assoc = currency.associations;
          for (let index = 0; index < assoc.length; index++) {
            let filterData = assoc[index].associations.find(x => x.id === item.value);
            cardArr.push(filterData);
          }
        }
      }
      let newArr = cardArr.filter(x => x !== undefined);
      newArr.map(x => cardType.filter(a => a.id === x.id).length > 0 ? null : cardType.push(x));
      Payload.data.specificDetails.cardType = cardType;
    }
    if (Payload.data.specificDetails !== undefined && Payload.data.specificDetails.specificDetailsMandatoryCheck !== undefined && Payload.data.specificDetails.specificDetailsMandatoryCheck === false) {
      delete Payload.data.specificDetails.specificDetailsMandatoryCheck;
    }
    if (Payload.data.addressAndContacts !== undefined && Payload.data.addressAndContacts.addressAndContactMandatoryCheck !== undefined && Payload.data.addressAndContacts.addressAndContactMandatoryCheck === false) {
      delete Payload.data.addressAndContacts.addressAndContactMandatoryCheck;
    }
    if (Array.isArray(Payload.data.addressAndContacts.contactId) && Payload.data.addressAndContacts.contactId.length) {
      removeEmptyObjectFromPayload(Payload.data.addressAndContacts)
    }
    Payload.data.productType = "corporate-card";
    finalPayload.product = Payload.data;
    eapiClient("/product/corporate-card/" + productId, {
      method: 'PUT',
      data: JSON.stringify(finalPayload)
    })
      .then(({ data }) => {
        this.props.resetcurrentProductCorporateCard();
        this.props.unBlockUi();
        this.props.history.push('/case-body');
      });
    let isItem = window.sessionStorage.getItem("isItem");
    if (isItem !== null) {
      window.sessionStorage.removeItem("isItem");
    }
  }

  updateFormData = (data, isSpecificDetails) => {
    if (data !== undefined && data.responseData !== undefined) {
      let specificDetails = data.responseData ? data.responseData.specificDetails : {};
      let addressAndContacts = data.responseData ? data.responseData.addressAndContacts : {};
      let country = data.responseData ? data.responseData.country.value.split(':')[data.responseData.country.value.split(':').length - 2].split('-').join('').toLowerCase() : '';
      let currencyType = [];
      let res = data.responseData.specificDetails !== undefined && data.responseData.specificDetails.cardAndCurrencies !== undefined ? data.responseData.specificDetails.cardAndCurrencies : [];
      for (let item of res) {
        for (let curr of item.currencyLst) {
          currencyType.push(curr);
        }
      }
      let cardType = [];
      for (let item of res) {
        cardType.push(item.cardType);
      }
      let supplierNameLst1 = null, supplierNameLst2 = null, supplierNameLst3 = null, supplierNameLst4 = null, supplierNameLst5 = null;
      let suppliers = data.responseData.specificDetails !== undefined && data.responseData.specificDetails.supplierNameLst !== undefined ? data.responseData.specificDetails.supplierNameLst : [];
      if (suppliers.length === 1) {
        supplierNameLst1 = suppliers[0];
      } if (suppliers.length === 2) {
        supplierNameLst1 = suppliers[0];
        supplierNameLst2 = suppliers[1];
      } if (suppliers.length === 3) {
        supplierNameLst1 = suppliers[0];
        supplierNameLst2 = suppliers[1];
        supplierNameLst3 = suppliers[2];
      } if (suppliers.length === 4) {
        supplierNameLst1 = suppliers[0];
        supplierNameLst2 = suppliers[1];
        supplierNameLst3 = suppliers[2];
        supplierNameLst4 = suppliers[3];
      } if (suppliers.length === 5) {
        supplierNameLst1 = suppliers[0];
        supplierNameLst2 = suppliers[1];
        supplierNameLst3 = suppliers[2];
        supplierNameLst4 = suppliers[3];
        supplierNameLst5 = suppliers[4];
      }
      let isItem = window.sessionStorage.getItem("isItem");
      if (isItem === null && isSpecificDetails === null) {
        this.setState({
          formData: {
            ...this.state.formData,
            ...data.responseData,
            specificDetails: {
              ...this.state.formData.specificDetails,
              ...specificDetails,
              cardType,
              currencyType,
              supplierNameLst1,
              supplierNameLst2,
              supplierNameLst3,
              supplierNameLst4,
              supplierNameLst5
            },
            addressAndContacts: {
              ...this.state.formData.addressAndContacts,
              ...addressAndContacts,
            },
          },
          selectedCountry: country,
          country: data ? data.responseData.country : '',
          corporateCardProduct: data ? data.responseData : {},
          applicableAccordions: getCountryAccordions((country)),
        });
      } else if (isItem === null && isSpecificDetails === true) {
        this.setState({
          formData: {
            ...this.state.formData,
            ...data.responseData,
            specificDetails: {
              ...this.state.formData.specificDetails,
              ...specificDetails,
              cardType,
              currencyType,
              supplierNameLst1,
              supplierNameLst2,
              supplierNameLst3,
              supplierNameLst4,
              supplierNameLst5
            },
            addressAndContacts: {
              ...this.state.formData.addressAndContacts,
            },
          },
          selectedCountry: country,
          country: data ? data.responseData.country : '',
          corporateCardProduct: data ? data.responseData : {},
          applicableAccordions: getCountryAccordions((country)),
        });
      } else if (isItem === null && isSpecificDetails === false) {
        this.setState({
          formData: {
            ...this.state.formData,
            ...data.responseData,
            specificDetails: {
              ...this.state.formData.specificDetails,
            },
            addressAndContacts: {
              ...this.state.formData.addressAndContacts,
              ...addressAndContacts,
            },
          },
          selectedCountry: country,
          country: data ? data.responseData.country : '',
          corporateCardProduct: data ? data.responseData : {},
          applicableAccordions: getCountryAccordions((country)),
        });
      } else {
        this.setState({
          formData: {
            ...this.state.formData,
            ...data.responseData,
            specificDetails: {
              ...this.state.formData.specificDetails,
            },
            addressAndContacts: {
              ...this.state.formData.addressAndContacts,
            },
          },
          selectedCountry: country,
          country: data ? data.responseData.country : '',
          corporateCardProduct: data ? data.responseData : {},
          applicableAccordions: getCountryAccordions((country)),
        });
      }
      this.props.setCaptureProductCorporateCard(this.state);
    }
  }

  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  getTabIndex = (index) => {
    if (!(index === this.props.displayTabIndex))
      this.props.setCorporateCardActiveTabIndex(index);
  }

  renderAccordions = () => {
    this.showHideFields();
    let accordionIndex = 1;
    let accordionsArray = [];
    let returnAccordionsArray = [];
    for (let [key, value] of Object.entries(this.state.pageJson.par)) {
      if (this.state.applicableAccordions !== undefined) {
        if ((key.startsWith('aemform_') && this.state.applicableAccordions.includes(value.name)) || key.startsWith('guidebutton_')) {
          accordionsArray.push({ ['accordionIndex']: accordionIndex, ['accordionName']: key, ['accordionContent']: value });
          accordionIndex += 1;
        }
      }
    }
    {
      this.state.currency !== undefined ?
        returnAccordionsArray = accordionsArray.map((accordionItem, acrdnIdx) => {
          let _formDataAccordionKey = accordionItem.accordionContent.name;
          let _status = ''
          if (accordionItem.accordionName.startsWith('aemform_')) {
            let relevantAccordionFields = this.passRelevantFields(_formDataAccordionKey);
            return (
              <CaseDetailAccordion
                key={'accordionItem' + accordionItem.accordionIndex}
                name={_formDataAccordionKey}
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`${accordionItem.accordionIndex}. ${accordionItem.accordionContent.title ? this.getTranslatedValue(accordionItem.accordionContent.title) || 'Form Details' : 'Form Details'}`}
                status={typeof this.state.status[_formDataAccordionKey] !== 'undefined' ? this.state.status[_formDataAccordionKey].status : ''}
                _onClickAccordionHeader={this.getTabIndex.bind(this, accordionItem.accordionIndex - 1)}
                accordionFields={accordionItem.accordionContent}
                formData={this.state.formData[_formDataAccordionKey] || {}}
                stateData={this.state}
                history={this.props.history}
                _accordionName={accordionItem.accordionContent.name}
                lang={this.props.lang.currentLang.lang}
                relevantFields={relevantAccordionFields}
                _dropDownDataSourceMap={this.dropDownDataSourceMap}
                translatedData={this.props.lang.translatedData}
                dropDownData={{
                  'customerLimitList': this.state.formData['customerLimitList'],
                  'statementFrequencyList': this.state.formData['statementFrequencyList'],
                  'preferredDayList': this.state.formData['preferredDayList'],
                  'availableAddresses': this.state.formData['availableAddresses'],
                  'availableContacts': this.state.formData['availableContacts'],
                  'cardAddresses': this.state.formData['cardAddresses'],
                  'pinAddresses': this.state.formData['pinAddresses'],

                } || {}}
                dropDownDataDisabled={this.state.disabledOptions}
                updateDisabledOptionArray={this.updateDisabledArray}
                _saveStateToSessionOnEdit={this.saveStateToSessionOnEdit}
                onChange={this.handleChange(_formDataAccordionKey)}
                _checkboxTaxonomy={this.state.currency}
                _submitTabdata={this.submitTabdata}
              />
            )
          } else if (accordionItem.accordionName.startsWith('guidebutton_')) {
            return (
              <div key={'accordionItem' + accordionItem.accordionIndex} className="form-buttons-section">
                <div className="form-buttons-wrapper">
                  <button className={accordionItem.accordionContent.bsClass} onClick={this.submitFormData}>
                    {this.getTranslatedValue(accordionItem.accordionContent.text) || `Save Changes`}
                  </button>
                </div>
              </div>
            )
          }
        })
        : ''
    }

    return returnAccordionsArray;

  }

  passRelevantFields = (accordionName) => {
    let relevantFields = [];
    let countryName = this.state.selectedCountry;
    if (countryName === "unitedkingdomhsbcbankplc") {
      countryName = "unitedkingdomhsbcuk";
    }
    let _accordionKey = countryName + '_' + accordionName;
    if (accordionFieldsMap.has(_accordionKey)) {
      let accordionFieldsArray = accordionFieldsMap.get(_accordionKey);
      relevantFields.push(...this.getRelevantFields(accordionName, accordionFieldsArray));
    };
    return relevantFields;
  }

  updateDisabledArray = (e) => {
    let currentDisabledOptions = { ...this.state.disabledOptions };
    if (e.type === 'removeAggregateForm') {
      let mapRemovalEntries = [], methodLabel;
      let nameArray = e.name.split('-');
      let tempAggregateFormData = { ...this.state.formData[e.accordionName] };
      for (let itemName of nameArray) {
        tempAggregateFormData = tempAggregateFormData[itemName];
      }
      if (nameArray[0] === 'submissionMethods') {
        let tempSubMethodobj = { ...this.state.formData[e.accordionName].submissionMethods[nameArray[nameArray.length - 2]] }
        let currMethod = tempSubMethodobj.submissionMethod.value.split(':');
        if (currMethod[currMethod.length - 2] === "submissionMethodA") {
          methodLabel = 'A';
        } else if (currMethod[currMethod.length - 2] === "submissionMethodB") {
          methodLabel = 'B';
        }
      }
      let processedData = tempAggregateFormData.map((item, i) => {
        if (i != e.idx) {
          return item;
        } else {
          for (let [k, v] of Object.entries(item)) {
            if (this.dropDownDataSourceMap.has(k)) {
              let pushEntry;
              if (nameArray[0] === 'submissionMethods') {
                pushEntry = nameArray[nameArray.length - 1] + methodLabel;
              } else {
                pushEntry = nameArray[nameArray.length - 1];
              }
              pushEntry += this.dropDownDataSourceMap.get(k) + '_' + v
              mapRemovalEntries.push(pushEntry);
            }
          }
        }
      });
      let filteredData = processedData.filter(item => item);
      let currentDisabledOptions = { ...this.state.disabledOptions };
      if (mapRemovalEntries.length > 0) {
        for (let sourceKey of mapRemovalEntries) {
          currentDisabledOptions[sourceKey.split('_')[0]] = currentDisabledOptions[sourceKey.split('_')[0]].filter(item => item != sourceKey.split('_')[1]);
        }
      }
      let accordionAggregateFormData = { ...this.state.formData[e.accordionName] };
      let accordionAggregatePointer = accordionAggregateFormData;
      for (let iName = 0; iName < nameArray.length - 1; iName++) {
        accordionAggregatePointer = accordionAggregatePointer[nameArray[iName]];
      }
      accordionAggregatePointer[nameArray[nameArray.length - 1]] = [...filteredData];
      let replaceFormData = { ...this.state.formData, [e.accordionName]: accordionAggregateFormData };
      let isCardDelivery = this.state.formData.addressAndContacts.cardDeliveryAddressId !== undefined ? this.state.formData.addressAndContacts.cardDeliveryAddressId : undefined;
      let isPinDelivery = this.state.formData.addressAndContacts.pinDeliveryAddressId !== undefined ? this.state.formData.addressAndContacts.pinDeliveryAddressId : undefined;
      if (isCardDelivery !== undefined) {
        delete this.state.disabledOptions.cardDeliveryAddressIdcardAddresses;
        delete currentDisabledOptions.cardDeliveryAddressIdcardAddresses;
      }
      if (isPinDelivery !== undefined) {
        delete this.state.disabledOptions.pinDeliveryAddressIdpinAddresses;
        delete currentDisabledOptions.pinDeliveryAddressIdpinAddresses;
      }
      this.setState({
        formData: replaceFormData,
        disabledOptions: currentDisabledOptions
      })
    } else {
      if (!e.removeItems && e.type !== 'emptyListOperation') {
        if (currentDisabledOptions[e.disbaledOptionKey]) {
          let replaceIdx = currentDisabledOptions[e.disbaledOptionKey].indexOf(e.currentValue);
          if (replaceIdx === -1) {
            currentDisabledOptions[e.disbaledOptionKey].push(e.updateValue);
          } else {
            //Either replace disabledOptions with other value or remove a value from disabledoptions array
            if (e.updateValue && e.updateValue.trim() !== "") {
              currentDisabledOptions[e.disbaledOptionKey][replaceIdx] = e.updateValue;
            } else {
              //To remove entries from disabledOptions array updateValue should be 'undefined' -> e.g. unchecking checkbox having dropdowns
              if (!e.updateValue) {
                let tempDisabledOptions = [...currentDisabledOptions[e.disbaledOptionKey]];
                currentDisabledOptions[e.disbaledOptionKey] = tempDisabledOptions.filter(item => item !== e.currentValue);
              }
            }
          }
        } else {
          currentDisabledOptions = { ...currentDisabledOptions, [e.disbaledOptionKey]: [e.updateValue] };
        }
      } else {
        //single or bulk removal of items from disabledOptions object, i.e. from different sources
        if (e.removeItems) {
          let removeItemsArray = e.removeItems;
          for (let rm of removeItemsArray) {
            currentDisabledOptions[rm.disbaledOptionKey] = currentDisabledOptions[rm.disbaledOptionKey].filter(item => item !== rm.currentValue);
          }
        } else if (e.type === 'emptyListOperation') {
          let _disableKeyName = e.disableKey;
          if (currentDisabledOptions[_disableKeyName]) {
            delete currentDisabledOptions[_disableKeyName]
          };
        }
      }
      let isCardDelivery = this.state.formData.addressAndContacts.cardDeliveryAddressId !== undefined ? this.state.formData.addressAndContacts.cardDeliveryAddressId : undefined;
      let isPinDelivery = this.state.formData.addressAndContacts.pinDeliveryAddressId !== undefined ? this.state.formData.addressAndContacts.pinDeliveryAddressId : undefined;
      if (isCardDelivery === undefined) {
        delete this.state.disabledOptions.cardDeliveryAddressIdcardAddresses;
        delete currentDisabledOptions.cardDeliveryAddressIdcardAddresses;
      }
      if (isPinDelivery === undefined) {
        delete this.state.disabledOptions.pinDeliveryAddressIdpinAddresses;
        delete currentDisabledOptions.pinDeliveryAddressIdpinAddresses;
      }
      this.setState({
        disabledOptions: currentDisabledOptions
      });
    }
  }

  getRelevantFields = (accordionName, fieldsArray = []) => {
    let retArr = [];
    let deleteKeysFromStateArr = [];
    for (let field of fieldsArray) {
      if (typeof field === 'string') {
        retArr.push(field);
      }
      else if (typeof field === 'object') {
        for (let [k, v] of field.entries()) {
          if (k === 'static_text' || k === "static_text_heading" || k === "static_text_note") {
            retArr.push(new Map([[k, v]]));
          } else {
            retArr.push(k);
            switch (k.split('_')[1]) {
              case 'CCCentralPay':
              case 'VCCentralPay':
              case 'PCCentralPay':
              case 'CCIndividualPay':
              case 'CCIndividualBillCPay':
              case 'LodgeCardCentralPay':
              case 'FuelCardCentralPay':
              case 'CorporateCard':
              case 'PurchasingCard':
              case 'VirtualCard':
              case 'LodgeCard':
              case 'OneCard':
              case 'FleetCard':
                let _parentArrayName = k.split(':')[0];
                if (_parentArrayName === 'currencyType' || _parentArrayName === 'cardType' || _parentArrayName === 'b2bSolution') {
                  if (this.state.formData[accordionName][_parentArrayName] && this.state.formData[accordionName][_parentArrayName].length > 0) {
                    for (let rptItem of this.state.formData[accordionName][_parentArrayName]) {
                      let splittedRptValue = rptItem.value.split(':');
                      if (splittedRptValue[splittedRptValue.length - 2] === k.split('_')[1]) {
                        retArr.push(new Map([[k, v]]));
                      }
                    }
                  }
                } else {
                  console.log('Unknown parent for other checkbox');
                }
                break;
              case 'isDiffCardDeliveryAdd':
              case 'isDiffPINDeliveryAdd':
                let addressReq = this.state.formData[accordionName][k.split('_')[1]];
                if (addressReq) {
                  retArr.push(...this.getRelevantFields(accordionName, v));
                } else {
                  if (k.split('_')[1] === 'isDiffCardDeliveryAdd') {
                    if (!this.state.formData[accordionName][k.split('_')[1]] && this.state.formData[accordionName]['cardDeliveryAddressId'] && this.state.formData[accordionName]['cardDeliveryAddressId'].trim() !== "") {
                      deleteKeysFromStateArr.push(`${accordionName}-cardDeliveryAddressId`);
                    }
                  }
                }
                break;
              case 'b2bSolution':
                let _arrayName = k.split(':')[0];
                if (_arrayName === 'b2bSolution') {
                  if (this.state.formData[accordionName][_arrayName] && this.state.formData[accordionName][_arrayName].length > 0) {
                    for (let rptItem of this.state.formData[accordionName][_arrayName]) {
                      let splittedRptValue = rptItem.value.split(':');
                      if (splittedRptValue[splittedRptValue.length - 2] === k.split('_')[1]) {
                        retArr.push(new Map([[k, v]]));
                      }
                    }
                  }
                } else {
                  console.log('Unknown parent for other checkbox');
                }
                break;

            }
          }
        }
      }
    }
    this.deleteKeysFromStateArr.push(...deleteKeysFromStateArr);
    return retArr;
  }

  showHideFields = () => {
    if (document.querySelector('[id^="paymentFacilitatorName"]') !== null && document.querySelector('[id^="merchantIdentificationNumber"]') !== null &&
      document.querySelector('[id^="purposeOfCardPayment"]') !== null && document.querySelector('[id^="supplierNameLst1"]') !== null && document.querySelector('[id^="supplierNameLst2"]') !== null &&
      document.querySelector('[id^="supplierNameLst3"]') !== null && document.querySelector('[id^="supplierNameLst4"]') !== null && document.querySelector('[id^="supplierNameLst5"]') !== null) {
      if (this.state.formData.specificDetails.b2bSolution === true) {
        document.querySelector('[id^="static_text_B2BTextField"]').classList.remove('noDisplay');
        document.querySelector('[id^="paymentFacilitatorName"]').classList.remove('noDisplay');
        document.querySelector('[id^="merchantIdentificationNumber"]').classList.remove('noDisplay');
        document.querySelector('[id^="purposeOfCardPayment"]').classList.remove('noDisplay');
        document.querySelector('[id^="supplierNameLst1"]').classList.remove('noDisplay');
        document.querySelector('[id^="addSupplier"]').classList.remove('noDisplay');
        if (this.state.formData.specificDetails.supplierNameLst1 === null) {
          document.querySelector('[id^="supplierNameLst2"]').classList.add('noDisplay');
          document.querySelector('[id^="supplierNameLst3"]').classList.add('noDisplay');
          document.querySelector('[id^="supplierNameLst4"]').classList.add('noDisplay');
          document.querySelector('[id^="supplierNameLst5"]').classList.add('noDisplay');
        }
        if (this.state.formData.specificDetails.supplierNameLst2 === null) {
          document.querySelector('[id^="supplierNameLst2"]').classList.add('noDisplay');
        }
        if (this.state.formData.specificDetails.supplierNameLst3 === null) {
          document.querySelector('[id^="supplierNameLst3"]').classList.add('noDisplay');
        }
        if (this.state.formData.specificDetails.supplierNameLst4 === null) {
          document.querySelector('[id^="supplierNameLst4"]').classList.add('noDisplay');
        }
        if (this.state.formData.specificDetails.supplierNameLst5 === null) {
          document.querySelector('[id^="supplierNameLst5"]').classList.add('noDisplay');
        }
        if (this.state.formData.specificDetails.supplierNameLst1 !== undefined && this.state.formData.specificDetails.supplierNameLst1 !== null) {
          if (this.state.formData.specificDetails.supplierNameLst2 !== undefined && this.state.formData.specificDetails.supplierNameLst2 !== null) {
            document.querySelector('[id^="supplierNameLst2"]').classList.remove('noDisplay');
            if (this.state.formData.specificDetails.supplierNameLst3 !== undefined && this.state.formData.specificDetails.supplierNameLst3 !== null) {
              document.querySelector('[id^="supplierNameLst3"]').classList.remove('noDisplay');
              if (this.state.formData.specificDetails.supplierNameLst4 !== undefined && this.state.formData.specificDetails.supplierNameLst4 !== null) {
                document.querySelector('[id^="supplierNameLst4"]').classList.remove('noDisplay');
                if (this.state.formData.specificDetails.supplierNameLst5 !== undefined && this.state.formData.specificDetails.supplierNameLst5 !== null) {
                  document.querySelector('[id^="supplierNameLst5"]').classList.remove('noDisplay');
                  document.querySelector('[id^="addSupplier"]').classList.add('noDisplay');
                }
              }
            }
          }
        }
      } else {
        document.querySelector('[id^="static_text_B2BTextField"]').classList.add('noDisplay');
        document.querySelector('[id^="paymentFacilitatorName"]').classList.add('noDisplay');
        document.querySelector('[id^="merchantIdentificationNumber"]').classList.add('noDisplay');
        document.querySelector('[id^="purposeOfCardPayment"]').classList.add('noDisplay');
        document.querySelector('[id^="supplierNameLst1"]').classList.add('noDisplay');
        document.querySelector('[id^="supplierNameLst2"]').classList.add('noDisplay');
        document.querySelector('[id^="supplierNameLst3"]').classList.add('noDisplay');
        document.querySelector('[id^="supplierNameLst4"]').classList.add('noDisplay');
        document.querySelector('[id^="supplierNameLst5"]').classList.add('noDisplay');
        document.querySelector('[id^="addSupplier"]').classList.add('noDisplay');
      }
    }
    let country = this.state.country.value.split(':')
    if (this.state.formData.specificDetails.cardType !== undefined && country !== undefined && this.state.formData.specificDetails.cardType.length !== 0 && country[country.length - 2] === 'UnitedStatesofAmerica') {
      let isCentralPay = this.state.formData.specificDetails.cardType.find(x => x.name === "Central Pay");
      if (document.querySelector('[id^="static_text_CardsAndPINs"]') !== null
        && document.querySelector('[id^="isDiffCardDeliveryAdd"]') !== null
        && document.querySelector('[id^="isDiffPINDeliveryAdd"]') !== null) {
        if (isCentralPay !== undefined) {
          document.querySelector('[id^="static_text_CardsAndPINs"]').classList.remove('noDisplay');
          document.querySelector('[id^="isDiffCardDeliveryAdd"]').classList.remove('noDisplay');
          document.querySelector('[id^="isDiffPINDeliveryAdd"]').classList.remove('noDisplay');
        }
        else {
          document.querySelector('[id^="static_text_CardsAndPINs"]').classList.add('noDisplay');
          document.querySelector('[id^="isDiffCardDeliveryAdd"]').classList.add('noDisplay');
          document.querySelector('[id^="isDiffPINDeliveryAdd"]').classList.add('noDisplay');
        }
      }
      if (document.querySelector('[id^="static_text_CardsAndPINs"]') !== null && document.querySelector('[id^="isDiffCardDeliveryAdd"]') !== null && document.querySelector('[id^="isDiffPINDeliveryAdd"]') !== null && document.querySelector('[id^="cardDeliveryAddressId"]') !== null && document.querySelector('[id^="forTheAttentionOfCard"]') !== null &&
        document.querySelector('[id^="pinDeliveryAddressId"]') !== null && document.querySelector('[id^="forTheAttentionOfPIN"]') !== null && document.querySelector('[id^="isDiffPINDeliveryAdd"]') !== null) {
        if (isCentralPay !== undefined) {
          document.querySelector('[id^="static_text_CardsAndPINs"]').classList.remove('noDisplay');
          document.querySelector('[id^="isDiffCardDeliveryAdd"]').classList.remove('noDisplay');
          document.querySelector('[id^="isDiffPINDeliveryAdd"]').classList.remove('noDisplay');
        }
        else {
          document.querySelector('[id^="static_text_CardsAndPINs"]').classList.add('noDisplay');
          document.querySelector('[id^="isDiffCardDeliveryAdd"]').classList.add('noDisplay');
          document.querySelector('[id^="isDiffPINDeliveryAdd"]').classList.add('noDisplay');
          document.querySelector('[id^="cardDeliveryAddressId"]').classList.add('noDisplay');
          document.querySelector('[id^="forTheAttentionOfCard"]').classList.add('noDisplay');
          document.querySelector('[id^="pinDeliveryAddressId"]').classList.add('noDisplay');
          document.querySelector('[id^="forTheAttentionOfPIN"]').classList.add('noDisplay');
        }
      }
    } else if (this.state.formData.specificDetails.cardType !== undefined && country !== undefined && this.state.formData.specificDetails.cardType.length === 0 && country[country.length - 2] === 'UnitedStatesofAmerica') {
      if (document.querySelector('[id^="static_text_CardsAndPINs"]') !== null && document.querySelector('[id^="isDiffCardDeliveryAdd"]') !== null && document.querySelector('[id^="isDiffPINDeliveryAdd"]') !== null) {
        document.querySelector('[id^="static_text_CardsAndPINs"]').classList.add('noDisplay');
        document.querySelector('[id^="isDiffCardDeliveryAdd"]').classList.add('noDisplay');
        document.querySelector('[id^="isDiffPINDeliveryAdd"]').classList.add('noDisplay');
      }
    }
    if (this.state.formData.specificDetails.currencyType !== undefined && this.state.formData.specificDetails.currencyType.length !== 0 && country !== undefined && country[country.length - 2] === 'Singapore') {
      let isVirtualCurr = this.state.formData.specificDetails.currencyType.find(x => x.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Singapore:cardType:VCCentralPay:SGD");
      if (document.querySelector('[id^="companyNameOnCard"]') !== undefined
        && document.querySelector('[id^="companyNameOnCard"]') !== null) {
        if (this.state.formData.specificDetails.currencyType.length === 1 && isVirtualCurr !== undefined) {
          document.querySelector('[id^="companyNameOnCard"]').classList.add('noDisplay');
        } else {
          document.querySelector('[id^="companyNameOnCard"]').classList.remove('noDisplay');
        }
      }
    }
  }

  getDocumentTitle = () => {
    if (!isEmptyObject(this.state.pageJson) && this.state.status !== undefined) {
      return `Product Requests - Review Product - Corporate Cards - ${this.state.countryName ? this.state.countryName + " -" : ""} HSBC GLCM`
    } else {
      return "Product Requests- HSBC GLCM"
    }
  }

  getSubHeading = () => {
    if (!isEmptyObject(this.state.corporateCardProduct) && this.state.corporateCardProduct.corporateCardAgent.name) {
      return this.state.corporateCardProduct.corporateCardAgent.name
    }
  }

  shouldRenderAccordion = () => {
    if (this.state.selectedCountry && this.state.selectedCountry.trim() !== '') {
      return this.renderAccordions()
    } else {
      return null
    }
  }

  getTranslatedValue = (value) => {
    if (value)
      return Translations(value, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    document.title = this.getDocumentTitle()

    return (
      (!isEmptyObject(this.state.pageJson) && this.state.status !== undefined) ?
        <div className="product-cc-container">
          <div className="pannel-heading-container">
            <h2 className="pannel-heading">{this.state.countryName}</h2>
            <p className="pannel-sub-heading">{this.getSubHeading()}</p>
            <p className="optional-text">{this.getTranslatedValue(this.state.pageJson.par.static_text_requiredText.title)}</p>
          </div>
          <div className="gdocs-clear-float">

          </div>
          <NavListAccordionWrapper open={this.props.displayTabIndex}>
            {this.shouldRenderAccordion()}
          </NavListAccordionWrapper>
        </div>
        : null
    )
  }
}

class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }
  setPayLoad({ specificDetails, addressAndContacts, id }) {
    this.data.specificDetails = specificDetails;
    this.data.addressAndContacts = addressAndContacts;
    this.data.id = id;
  }
}

const mapStateToProps = state => ({
  lang: state.lang,
  cases: state.cases,
  currentProductCorporateCard: state.currentProductCorporateCard.data.formData,
  displayTabIndex: state.currentProductCorporateCard.activeTabIndex
});

const mapDispatchToProps = dispatch => {
  return {
    setCaptureProductCorporateCard: data => {
      dispatch(setCaptureProductCorporateCard(data));
    },
    setAddresses: addresses => {
      dispatch(setAddresses(addresses));
    },
    setPersons: persons => {
      dispatch(setPersons(persons));
    },
    resetcurrentProductCorporateCard: () => {
      dispatch(resetcurrentProductCorporateCard());
    },
    setCorporateCardActiveTabIndex: index => {
      dispatch(setCorporateCardActiveTabIndex(index))
    },
    resetCorporateCardActiveTabIndex: () => {
      dispatch(resetCorporateCardActiveTabIndex())
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductCorporateCard);


// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductCorporateCard/index.js